/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CountryView } from '../model/countryView';
import { HttpError } from '../model/httpError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CountriesService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Gets a Country object&lt;br&gt;&lt;br&gt;Countries by name and Code&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_countries
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countriesByExternalKeyIdGet(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<CountryView>;
    public countriesByExternalKeyIdGet(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CountryView>>;
    public countriesByExternalKeyIdGet(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CountryView>>;
    public countriesByExternalKeyIdGet(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling countriesByExternalKeyIdGet.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CountryView>('get',`${this.basePath}/Countries/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for Country objects&lt;br&gt;&lt;br&gt;Countries by name and Code&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_countries
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param group This parameter is used to group results.                         No field names are supported/configured to be allowed for this endpoint.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: countryId.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: countryId.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is countryId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - countryId would sort by updateDateTime ascending and then countryId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param countryId The unique identifier of this record.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the countryId field and returns all available results that match.   You can use &gt;10 to search for all countryIds greater than 10. You can use [1,2,3] to search for countryIds that match either 1, 2 or 3. You can use this parameter multiple times. eg countryId&#x3D;&gt;5&amp; countryId&#x3D;&lt;10 would search for all countryIds between 5 and 10.
     * @param name &lt;br&gt;This parameter searches for the name field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param a2code &lt;br&gt;This parameter searches for the a2code field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param createDateTime The date and time this record was created.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the createDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all createDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for createDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg createDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; createDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all createDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param updateDateTime The last date and time this record was updated.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the updateDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all updateDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for updateDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg updateDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; updateDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all updateDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param lastUpdateByUserId The userId of the last person to modify this record.&lt;br&gt;This parameter searches for the lastUpdateByUserId field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param status &lt;br&gt;This parameter searches for the status field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param externalKey The unique external key set by the current user accessing the API&lt;br&gt;This parameter searches for the externalKey field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countriesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, countryId?: number, name?: string, a2code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, status?: string, externalKey?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CountryView>>;
    public countriesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, countryId?: number, name?: string, a2code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, status?: string, externalKey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CountryView>>>;
    public countriesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, countryId?: number, name?: string, a2code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, status?: string, externalKey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CountryView>>>;
    public countriesGet(ridChain?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, countryId?: number, name?: string, a2code?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, status?: string, externalKey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (countryId !== undefined && countryId !== null) {
            queryParameters = queryParameters.set('countryId', <any>countryId);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }
        if (a2code !== undefined && a2code !== null) {
            queryParameters = queryParameters.set('a2code', <any>a2code);
        }
        if (createDateTime !== undefined && createDateTime !== null) {
            queryParameters = queryParameters.set('createDateTime', <any>createDateTime);
        }
        if (updateDateTime !== undefined && updateDateTime !== null) {
            queryParameters = queryParameters.set('updateDateTime', <any>updateDateTime);
        }
        if (lastUpdateByUserId !== undefined && lastUpdateByUserId !== null) {
            queryParameters = queryParameters.set('lastUpdateByUserId', <any>lastUpdateByUserId);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (externalKey !== undefined && externalKey !== null) {
            queryParameters = queryParameters.set('externalKey', <any>externalKey);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CountryView>>('get',`${this.basePath}/Countries/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a Country object&lt;br&gt;&lt;br&gt;Countries by name and Code&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_countries
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countriesIdGet(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<CountryView>;
    public countriesIdGet(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CountryView>>;
    public countriesIdGet(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CountryView>>;
    public countriesIdGet(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling countriesIdGet.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CountryView>('get',`${this.basePath}/Countries/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
